import Phaser from 'phaser';
import { BRAND, HEX } from '../config';
import { presentLogical } from '../hidpi';

export class BootScene extends Phaser.Scene {
  constructor() {
    super('BootScene');
  }

  preload() {
    this.load.image('sj-logo', 'assets/sj-logo-white.png');
    this.load.image('sj-icon', 'assets/sj-icon.png');
  }

  create() {
    const { width, height } = presentLogical(this);

    // Background gradient (top sky → ink)
    this.cameras.main.setBackgroundColor(BRAND.ink);
    const grad = this.add.graphics();
    grad.fillGradientStyle(BRAND.skyTop, BRAND.skyTop, BRAND.ink, BRAND.ink, 0.7, 0.7, 0, 0);
    grad.fillRect(0, 0, width, height / 2);

    // Logo
    const logo = this.add.image(width / 2, height / 2 - 30, 'sj-logo');
    const targetH = 80;
    logo.setScale(targetH / logo.height);

    // Tagline
    this.add
      .text(width / 2, height / 2 + 28, 'SOLAR INSTALLER', {
        fontFamily: 'Albert Sans, sans-serif',
        fontSize: '22px',
        color: HEX.amber,
        fontStyle: 'bold',
      })
      .setOrigin(0.5)
      .setLetterSpacing(3);
    this.add
      .text(width / 2, height / 2 + 56, 'THE GAME', {
        fontFamily: 'Albert Sans, sans-serif',
        fontSize: '12px',
        color: HEX.greyDim,
        fontStyle: 'bold',
      })
      .setOrigin(0.5)
      .setLetterSpacing(4);

    // Bottom red accent bar
    const g = this.add.graphics();
    g.fillStyle(BRAND.red, 1);
    g.fillRect(0, height - 6, width, 6);

    this.time.delayedCall(900, () => this.scene.start('MenuScene'));
  }
}
